import React from "react";
import { Grid, withStyles, Checkbox } from "@material-ui/core";

const styles = (theme) => ({
  safetyInfo: {
    fontSize: theme.textFontSize,
    lineHeight: "19px",
    color: theme.error,
    padding: "3px 20px",
    wordBreak: "break-word",
  },
  checkboxContainer: {
    fontSize: theme.textFontSize,
    padding: "0px 15px",
  },
  root: {
    padding: "5px",
  },
});

const SafetyData = ({ classes, safetyData, isOK, onIsOKCLick }) => {
  return (
    <Grid container>
      {safetyData.map((safetyInfo, index) => (
        <div
          className={classes.safetyInfo}
          key={`safetyInfo-${index}`}
        >{safetyInfo.message}</div>
      ))}
      <div className={classes.checkboxContainer}>
        <Checkbox
          classes={{
            root: classes.root,
          }}
          color="primary"
          onChange={onIsOKCLick}
          checked={isOK}
        />
        OK
      </div>
    </Grid>
  );
};

export default withStyles(styles)(SafetyData);
